import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import Main from "../components/Main";
import { MACHINE_TYPE } from "../assets/constants/constants";
import { StoredValues, WeatherData } from "../assets/interfaces/Dashboard";

import {
  getMachineLocation,
  getWeatherService,
} from "../assets/APIFuctions/DashboardFunctions";
import HelperService from "../Services/HelperService";
import WebService from "../Services/WebService";
import { useDispatch } from "react-redux";

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [machine_id, setMachineId] = useState("");
  const [userId, setUserId] = useState("");
  const pathParts = location.pathname.split("/");
  const dispatch = useDispatch();

  useEffect(() => {

    if (pathParts?.length === 6) setMachineId(pathParts[pathParts.length - 2]);
    else if (pathParts?.length === 7 && location?.pathname?.startsWith("/dashboard-")) {
      setMachineId(pathParts[pathParts.length - 3]);
      setUserId(pathParts[pathParts.length - 1]);
    } if (pathParts?.length === 7 && location?.pathname?.startsWith("/command-center/dashboard-")) {
      setMachineId(pathParts[pathParts.length - 2]);
      // alert(pathParts[pathParts.length - 2])
    }
    // if (pathParts?.length === 8 && location?.pathname?.startsWith("/command-center/dashboard-")) {
    //   setMachineId(pathParts[pathParts.length - 1]);
    //   // alert(pathParts[pathParts.length - 1])
    //   setUserId(pathParts[pathParts.length - 1]);
    // }



  }, [location]);


  const Vanila = React.lazy(
    () => {
      console.log("Loading Vanila...");
      return import("../components/DashboardVanilla/Vanilla");
    }
  );
  const Dashboard = React.lazy(
    () => {
      console.log("Loading Dashboard...");
      return import("../components/Dashboard/Dashboard");
    }
  );
  const Ultimate = React.lazy(

    () => {
      console.log("Loading Ultimate...");
      return import("../components/DashboardUltimate/Ultimate");
    }
  );


  useEffect(() => {
    if (location?.pathname?.startsWith("/command-center/dashboard-")) {
      setLocalStorageAndNavigate(machine_id, "COMMAND_CENTER");
    }
    if (location?.pathname?.startsWith("/client/dashboard-")) {
      setLocalStorageAndNavigate(machine_id, "CLIENT");
    } else if (checkLocalStorageForDashboard()) {
      let storedLocalStorageData: StoredValues | null = {
        indoorSensorId: "",
        outdoorSensorId: "",
        longitude: "",
        lattitude: "",
        siteId: "",
        machineId: "",
        machineType: "",
        companyId: "",
        companyLogo: "",
        tag: "",
        companyName: ""
      };

      if (localStorage.getItem(`machine_data_${machine_id}`)) {
        try {
          let storedData = localStorage.getItem(`machine_data_${machine_id}`);
          if (storedData) storedLocalStorageData = JSON.parse(storedData);
        } catch (e) {
          storedLocalStorageData = null;
        }
      }
      let previousDashboardType = storedLocalStorageData?.machineType;
      const selectedSitedId = storedLocalStorageData?.siteId;
      const companyId = storedLocalStorageData?.companyId;
      const machindeId = storedLocalStorageData?.machineId;
      const outdoorSensorId = storedLocalStorageData?.outdoorSensorId;

      if (previousDashboardType === MACHINE_TYPE.ULTIMATE) {
        if (pathParts?.length === 7 && userId)
          navigate(
            `/dashboard-ultimate/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}/${userId}`
          );
        else if (pathParts?.length === 6)
          navigate(
            `/dashboard-ultimate/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}`
          );
      } else if (previousDashboardType === MACHINE_TYPE.VANILA) {
        if (pathParts?.length === 7 && userId)
          navigate(
            `/dashboard-vanilla/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}/${userId}`
          );
        else if (pathParts?.length === 6)
          navigate(
            `/dashboard-vanilla/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}`
          );
      } else if (previousDashboardType === MACHINE_TYPE.ULTRAPRO) {
        if (pathParts?.length === 7 && userId)
          navigate(
            `/dashboard-ultrapro/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}/${userId}`
          );
        else if (pathParts?.length === 6)
          navigate(
            `/dashboard-ultrapro/${selectedSitedId}/${companyId}/${machindeId}/${outdoorSensorId}`
          );
      }
    } else if (location?.pathname?.startsWith("/dashboard-") && machine_id) {
      setLocalStorageAndNavigate(machine_id, "DASHBOARD");
    }
    // }
  }, [machine_id]);
  const checkLocalStorageForDashboard = () => {
    let flag = false;
    if (localStorage.getItem(`machine_data_${machine_id}`)) {
      console.log(
        localStorage.getItem(`machine_data_${machine_id}`),
        "machin data"
      );

      flag = true;
    } else {
      flag = false;
    }
    return flag;
  };

  const setLocalStorageAndNavigate = (machineId1: any, type: string) => {
    if (machineId1) {
      return WebService.getAPI({
        action: `app/station-details?station_id=${machineId1}`,
        body: null,
      })
        .then((res: any) => {
          if (res?.result) {
            let obj: StoredValues = {
              indoorSensorId: res?.result?.indoorSensorId,
              outdoorSensorId: res?.result?.outdoorSensorId,
              longitude: res?.result?.longitude,
              lattitude: res?.result?.lattitude,
              siteId: res?.result?.siteId,
              machineId: res?.result?.id,
              machineType: res?.result?.machineType,
              companyId: res?.result?.companyId,
              companyLogo: res?.result?.companyLogo,
              tag: res?.result?.tag,
              companyName: res?.result?.companyName
            };

            localStorage.setItem(
              `machine_data_${obj?.machineId}`,
              JSON.stringify(obj)
            );
            if (obj?.companyName) {
              localStorage.setItem("companyName", obj.companyName);
            }
            if (obj?.lattitude && obj?.longitude)
              getWeatherData(obj?.lattitude, obj?.longitude, res?.result?.id, obj?.companyName);

            if (type === "COMMAND_CENTER") {
              if (obj.machineType === MACHINE_TYPE.ULTIMATE)
                navigate(
                  `/command-center/dashboard-ultimate/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
              else if (obj.machineType === MACHINE_TYPE.VANILA)
                navigate(
                  `/command-center/dashboard-vanilla/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
              else if (obj.machineType === MACHINE_TYPE.ULTRAPRO) {
                navigate(
                  `/command-center/dashboard-ultrapro/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
              }
            }
            if (type === "CLIENT") {
              if (obj.machineType === MACHINE_TYPE.ULTIMATE)
                navigate(
                  `/client/dashboard-ultimate/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
              else if (obj.machineType === MACHINE_TYPE.VANILA)
                navigate(
                  `/client/dashboard-vanilla/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
              else if (obj.machineType === MACHINE_TYPE.ULTRAPRO)
                navigate(
                  `/client/dashboard-ultrapro/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                );
            } else if (type === "DASHBOARD") {
              if (obj.machineType === MACHINE_TYPE.ULTIMATE) {
                if (pathParts?.length === 7 && userId)
                  navigate(
                    `/dashboard-ultimate/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}/${userId}`
                  );
                else if (pathParts?.length === 6)
                  navigate(
                    `/dashboard-ultimate/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                  );
              } else if (obj.machineType === MACHINE_TYPE.VANILA) {
                if (pathParts?.length === 7 && userId)
                  navigate(
                    `/dashboard-vanilla/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}/${userId}`
                  );
                else if (pathParts?.length === 6)
                  navigate(
                    `/dashboard-vanilla/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                  );
              } else if (obj.machineType === MACHINE_TYPE.ULTRAPRO) {
                if (pathParts?.length === 7 && userId)
                  navigate(
                    `/dashboard-ultrapro/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}/${userId}`
                  );
                else if (pathParts?.length === 6)
                  navigate(
                    `/dashboard-ultrapro/${obj.siteId}/${obj.companyId}/${obj.machineId}/${obj.outdoorSensorId}`
                  );
              }
            }
          }
        })

        .catch((error: any) => {
          return error;
        });
    }
  };
  const getWeatherData = (lat: any, long: any, machineId: any, compName?: string) => {
    let resolvedCompanyName = compName || "";
    if (!resolvedCompanyName) {
      try {
        const storedMachine = localStorage.getItem(`machine_data_${machineId}`);
        if (storedMachine) {
          const parsed = JSON.parse(storedMachine);
          resolvedCompanyName = parsed?.companyName || "";
        }
      } catch (e) { }
    }
    if (!resolvedCompanyName) {
      resolvedCompanyName = localStorage.getItem("companyName") || "";
    }

    let data: WeatherData = {
      temperature: "",
      city: "",
      weatherDiscription: "",
      icon: "",
      companyName: resolvedCompanyName,
    };
    const currentDate = new Date().toISOString().split("T")[0];
    getWeatherService(lat, long).then((response: any) => {
      data = {
        temperature: (response?.data?.main?.temp - 273.15).toFixed(2),
        city: "",
        weatherDiscription: response?.data?.weather[0]?.description,
        icon: HelperService.getIconForWeather(response?.data?.weather[0]?.icon),
        companyName: resolvedCompanyName,
      };
      localStorage.setItem(
        `weatherDataCollectedDate_${machineId}`,
        currentDate
      );
      localStorage.setItem(
        `weatherAPIData_${machineId}`,
        JSON.stringify(data)
      );
    });
    getMachineLocation(lat, long).then((response: any) => {
      if (
        response &&
        response?.length > 0 &&
        response[0].address_components.length > 0
      ) {
        let locationData = response;
        let cityLocation: any = "";
        let part1 =
          locationData[0]?.address_components[0] &&
          locationData[0]?.address_components[0]?.long_name;
        let part2 =
          locationData[0]?.address_components[1] &&
          locationData[0]?.address_components[1]?.long_name;
        let part3 =
          locationData[0]?.address_components[2] &&
          locationData[0]?.address_components[2]?.long_name;

        cityLocation = [part1, part2, part3]
          .filter((part) => part !== undefined)
          .join(" ");

        localStorage.setItem(
          `weatherAPIData_${machineId}`,
          JSON.stringify({ ...data, city: cityLocation, companyName: resolvedCompanyName })
        );
      }
    });
  };

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/"
            element={
              <Suspense fallback={<>Loading...</>}>
                <Main />
              </Suspense>
            }
          >
            <Route
              path="/dashboard-ultrapro/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
              path="/dashboard-ultrapro/:site_id/:company_id/:machine_id/:outdoorSensorId/:id"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Dashboard />
                </Suspense>
              }
            />

            <Route
              path="/dashboard-ultimate/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Ultimate />
                </Suspense>
              }
            />
            <Route
              path="/dashboard-ultimate/:site_id/:company_id/:machine_id/:outdoorSensorId/:id"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Ultimate />
                </Suspense>
              }
            />
            <Route
              path="/dashboard-vanilla/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Vanila />
                </Suspense>
              }
            />
            <Route
              path="/dashboard-vanilla/:site_id/:company_id/:machine_id/:outdoorSensorId/:id"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Vanila />
                </Suspense>
              }
            />

            <Route
              path="/command-center/dashboard-ultrapro/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Dashboard />
                </Suspense>
              }
            />

            <Route
              path="/command-center/dashboard-ultimate/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Ultimate />
                </Suspense>
              }
            />
            <Route
              path="/command-center/dashboard-vanilla/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Vanila />
                </Suspense>
              }
            />
            <Route
              path="/client/dashboard-ultrapro/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Dashboard />
                </Suspense>
              }
            />

            <Route
              path="/client/dashboard-ultimate/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Ultimate />
                </Suspense>
              }
            />
            <Route
              path="/client/dashboard-vanilla/:site_id/:company_id/:machine_id/:outdoorSensorId"
              element={
                <Suspense fallback={<>Loading...</>}>
                  <Vanila />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
